import { PermitData } from '@EcamModel/model';
import { Button, Divider, Stack, Typography } from '@mui/material';
import color from '@theme/Colors';
import { OrangeStack } from './PCDetail';

type Props = {
    permitData: PermitData;
    handleOpenPopUp: () => void;
};

export default function PermitDuplicate({ permitData, handleOpenPopUp }: Props) {
    return permitData?.hasPermit ? (
        <OrangeStack mt={2} direction={'row'} justifyContent={'space-between'}>
            <Stack direction={'column'} gap={1}>
                <Typography>Permit exists for this VRN with in this location at the time of issue</Typography>
                <Stack
                    direction="row"
                    divider={
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ borderRightWidth: 1, borderColor: color.textPrimary, py: '3px' }}
                        />
                    }
                    spacing={2}
                >
                    <Typography>Bay number: {permitData.permitInfo.bayNumber ?? ''}</Typography>
                    <Typography>Source: {permitData.permitInfo.source}</Typography>
                    <Typography>Tenant: {permitData.permitInfo.tenant}</Typography>
                </Stack>
            </Stack>
            <Button variant="errorOutlined" onClick={handleOpenPopUp}>
                Cancel this PC
            </Button>
        </OrangeStack>
    ) : (
        <></>
    );
}
